import { Card } from "@mui/material";
import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { ProductFormData } from "@/components/screens/ProductFormPage/types";
import useGetAllCategories from "@/hooks/requests/category/use-get-all-categories";
import { useGetLinkedCategories } from "@/hooks/requests/linked-product-category";
import { ProductFormMessages } from "@/messages/products/product-form.messages";

import CategoryTree from "./components/CategoryTree";

type Props = {
  messages: ProductFormMessages;
  productId?: number | null;
  cardHeightPx: number;
};

function Categories({ messages, productId, cardHeightPx }: Props) {
  const [initialized, setInitialized] = useState(false);
  const { data } = useGetAllCategories();
  const { data: linkedCategories } = useGetLinkedCategories({ productId: productId || null });
  const { setFieldValue, values } = useFormikContext<ProductFormData>();

  // Carregar categorias vinculadas ao montar (apenas uma vez, e só se não houver seleções)
  useEffect(() => {
    if (linkedCategories && linkedCategories.length > 0 && !initialized && values.selectedCategories.length === 0) {
      const categoryIds = linkedCategories.map(lc => lc.categoryId);
      setFieldValue("selectedCategories", categoryIds);
      setInitialized(true);
    }
  }, [linkedCategories, setFieldValue, initialized, values.selectedCategories]);

  const handleCategorySelectionChange = (categories: number[]) => {
    setFieldValue("selectedCategories", categories);
  };

  return (
    <Card
      sx={{
        height: cardHeightPx,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <MDBox
        p={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <MDBox display="flex" justifyContent="space-between" flexShrink={0}>
          <MDTypography variant="h5" fontWeight={"bold"}>
            {messages.categoryTitle}
          </MDTypography>
        </MDBox>

        <MDBox
          mt={1}
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            pr: 0.5,
          }}
        >
          <CategoryTree
            categories={data}
            categoriesArray={values.selectedCategories || []}
            messages={messages}
            onSelectionChange={handleCategorySelectionChange}
          />
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default Categories;
